import { createSlice, } from '@reduxjs/toolkit';

interface IFilterText {
    clearFiltersLabel: string;
    noResultsMessage: string;
    maxItemsPerPage: number;
}

const initialState: IFilterText = (window as any).filterSectionModel ? (window as any).filterSectionModel : null;

const filterTextSlice = createSlice({
    name: 'filter-text-slice',
    initialState,
    reducers: { 
    },
})

export default filterTextSlice;